module.exports = __webpack_public_path__ + "img/sprite-side-effects.dceb74d4.png";